import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";

// components
import { AppComponent } from "./app.component";

// routes
import { DocumentManagementModule } from "./routes/document-management/document-management.module";

// shared modules
import { ComponentsModule } from "./components/components.module";
import { SharedModule } from "@app/commons/sharad.module";
import { LoginComponent } from "./routes/login/login.component";
import { DashboardComponent } from "./routes/dashboard/dashboard.component";
import { PdfViewerFullScreenModule } from "./routes/pdf-viewer-full-screen/pdf-viewer-full-screen.module";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { bearerTokenInterceptor, sessionEndCheckInterceptor } from "./commons/interceptors/auth.interceptor";
import { AdminManagementModule } from "./routes/admin-management/admin-management.module";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotAuthorizedComponent } from './routes/not-authorized/not-authorized.component';
import { ForgotPasswordComponent } from "./routes/forgot-password/forgot-password.component";

@NgModule({
  declarations: [AppComponent, LoginComponent, NotAuthorizedComponent, ForgotPasswordComponent],
  imports: [
    DashboardComponent,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    AdminManagementModule,
    DocumentManagementModule,
    PdfViewerFullScreenModule,
    ComponentsModule,
    BrowserAnimationsModule
  ],
  providers: [
    provideHttpClient(withInterceptors([bearerTokenInterceptor, sessionEndCheckInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
